import { FilterData, FilterJsonProperties, FilterJsonType, FilterPropertyType } from '@/entities/catalog-brands'

/**
 * Get filter json properties from form
 * @param filterProperties
 * @param firstPath
 */
export const getFilterJsonFromProperties = (
	filterProperties: FilterData | void,
	firstPath: string
): FilterJsonProperties => {
	if (!filterProperties) {
		return { LIST_SECTION_CODE: { type: FilterJsonType.Default, value: [firstPath] } }
	}

	return filterProperties?.PROPERTIES.reduce(
		(acc, obj) => {
			const checkedValues = obj.VALUES.filter(val => val.CHECKED)

			if (checkedValues.length) {
				acc[obj.CODE] = {
					type: obj.PROPERTY_TYPE !== FilterPropertyType.Number ? FilterJsonType.Default : FilterJsonType.Price,
					value: [...checkedValues.map(({ FILTERED_VALUE, VALUE }) => FILTERED_VALUE || VALUE)]
				}
			}

			return acc
		},
		{ LIST_SECTION_CODE: { type: FilterJsonType.Default, value: [firstPath] } }
	)
}
